module.exports = __webpack_public_path__ + "media/images/home/testimonials/kiana-827da185a4531ace500193fda3dcd3d4.jpg";